import type { Context, TextMapGetter, TextMapPropagator, TextMapSetter } from "@opentelemetry/api";
import { isSpanContextValid, trace } from "@opentelemetry/api";

const AMZN_TRACE_ID_HEADER = "X-Amzn-Trace-Id";
/** Always mark as sampled so downstream (ALB/logs) treat the client span as recorded. */
const SAMPLED_FLAGS = "01";

/**
 * Sets X-Amzn-Trace-Id in X-Ray Root= form, then appends the W3C traceparent
 * so ALB access logs stay substring-searchable by client trace/span ids.
 */
export class AmznTraceIdPropagator implements TextMapPropagator {
  inject(context: Context, carrier: unknown, setter: TextMapSetter): void {
    const spanContext = trace.getSpanContext(context);
    if (!spanContext || !isSpanContextValid(spanContext)) return;

    const { traceId, spanId } = spanContext;
    const traceparent = `00-${traceId}-${spanId}-${SAMPLED_FLAGS}`;
    const xAmznTraceId = `Root=1-${traceId.slice(0, 8)}-${traceId.slice(8)};${traceparent}`;
    setter.set(carrier, AMZN_TRACE_ID_HEADER, xAmznTraceId);
  }

  extract(context: Context, _carrier: unknown, _getter: TextMapGetter): Context {
    return context;
  }

  fields(): string[] {
    return [AMZN_TRACE_ID_HEADER];
  }
}
